import React from 'react'

const SvgKanbanFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4zm4 3a1 1 0 00-1-1H5a1 1 0 00-1 1v10.001a1 1 0 001 1h2a1 1 0 001-1V5zm5-1a1 1 0 011 1v5.997a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2zm7 1a1 1 0 00-1-1h-2a1 1 0 00-1 1l.001 14a1 1 0 001 1h2a1 1 0 001-1L20 5z'
    />
  </svg>
)

export default SvgKanbanFilled
